import manager from 'app/module46/component-manager.js';

manager.register('action', (component, elements, attributes, properties) => {
	
	const container = document.querySelector(attributes['containerSelector']);
	const loader = document.querySelector(attributes['loaderSelector']);

	let xhr = null;

	component.addEventListener('click', function(ev) {

		ev.preventDefault();

		const url = this.dataset.url;

		if(url) {

			if(loader) {
				$(loader).stop().show();
			}

			if(xhr) {
				xhr.abort();
			}
	
			xhr = manager.get(url, (response) => {

				container.innerHTML = response;

				manager.execute(container);

				if(loader) {
					$(loader).stop().fadeOut();
				}
			});
		}
	});

});
